import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-closet-equivent-tab',
    templateUrl: './closet-equivent-tab.component.html',
    styleUrls: ['./closet-equivent-tab.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ClosetEquiventTabComponent {
  @Input() product;
}
